module.exports = __webpack_public_path__ + "img/holiday.c1319547.svg";